import { Divider, Grid } from "@material-ui/core"
import React from "react"

const TitleElement = (props) => {
    return (
        <div>
            <Grid container direction="row" justifyContent="flex-start" spacing={4} alignItems="center">
                <Grid item>
                    <Grid container direction="column" justifyContent="center" spacing={0} alignItems="flex-start">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {props.title}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {props.element}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {props.divider ?
                <div>
                    <br />
                    <Divider />
                    <br />
                </div>
                :
                null}
        </div>
    )

}

export default TitleElement